// SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>
//
// SPDX-License-Identifier: MPL-2.0
export class HttpError extends Error {
  constructor(message, status) {
    super(message);
    this.name = 'HttpError';
    this.status = status;
  }
}

/** Use this when an unexpected value appears */
export class ValidationError extends Error {
  constructor(message) {
    super(message);
    this.name = 'ValidationError';
  }
}

/** Used for errors that happened in the backend */
export class BackendError extends Error {
  constructor(message) {
    super(message);
    this.name = 'BackendError';
  }
}

/** Somehow the api might have listed an id of a job that doesn't exist. Eg. the backend was reset */
export class JobMissingError extends Error {
  constructor(message) {
    super(message);
    this.name = 'JobMissingError';
  }
}

/** When the user comes back too late the job might be deleted on the server */
export class JobDeletedError extends Error {
  constructor(message) {
    super(message);
    this.name = 'JobDeletedError';
  }
}
